module.exports = __webpack_public_path__ + "static/media/Jim Philipps Headshot.1db0884c.jpeg";